import CryptoJS from 'crypto-js';
import Mission115Helper from '../Helpers/115/115MisionHelper';
export default {
  data() {
    return {
      menuItems: [],
      userItems: [],
      countryItems: [],
      baseInformationItems: [],
      appInformationItems: [],
      drugItems: [],
      changeRoleModal: false,
      userRoles: [],
      settingItems: [],
      reportItems: [],
      currentRoleId: null,
      moduleName: '',
      userInformation: null,
      myModuleId: null,
    };
  },
  mixins: [Mission115Helper],
  methods: {
    defineMenuItems: function (user) {
      this.userInformation = user;
      let bytes = CryptoJS.AES.decrypt(localStorage.getItem('dash'), 'f9rr8Y2D96Klh87N');
      let moduleId = '';
      if (bytes.sigBytes != 0) {
        moduleId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } else {
        moduleId = '';
      }
      this.myModuleId = moduleId;
      this.menuItems = [];
      this.userItems = [];
      this.drugItems = [];
      this.appInformationItems = [];
      this.countryItems = [];
      this.baseInformationItems = [];
      this.settingItems = [];
      this.currentRoleId = moduleId;
      if (moduleId == 1) {
        this.moduleName = 'ادمین آسایار';
        //admin
        this.menuItems.push(
          {
            title: 'کاربران',
            icon: 'mdi-account-multiple',
            type: '1',
            id: 1,
            module: 'admin',
          },
          {
            title: 'تقسیمات کشوری',
            icon: 'mdi-collage',
            type: '1',
            id: 2,
            module: 'admin',
          },
          {
            title: 'اطلاعات پایه',
            icon: 'mdi-book',
            type: '1',
            id: 3,
            module: 'admin',
          },
          {
            title: 'اطلاعات سامانه',
            icon: 'mdi-book-open-page-variant ',
            type: '1',
            id: 4,
            module: 'admin',
          },
          {
            title: 'مدیریت داروها',
            icon: 'mdi-pill-multiple',
            type: '1',
            id: 5,
            module: 'admin',
          },
          {
            title: 'تنظیمات',
            icon: 'mdi-cog',
            type: '1',
            id: 6,
            module: 'admin',
          },
        );
        this.userRoleTitle = 'مدیر سیستم';
        this.userItems.push(
          { title: 'کاربران', id: 1 },
          { title: 'گروه های کاربری', id: 2 },
          { title: 'سمت ها', id: 3 },
          { title: 'مدارک تحصیلی', id: 4 },
        );
        this.countryItems.push(
          { title: 'استان', id: 1 },
          { title: 'شهرستان', id: 2 },
          { title: 'ناحیه', id: 3 },
        );
        this.baseInformationItems.push(
          { title: 'بیمارستان ها', id: 1 },
          { title: 'پایگاه ها', id: 2 },
          { title: 'سایر ارگان ها', id: 3 },
          { title: 'نوع وسایل نقلیه', id: 4 },
          { title: 'سوالات عمومی', id: 5 },
          { title: 'افراد ناتوان', id: 6 },
          { title: 'وسایل نقلیه', id: 7 },
          { title: 'گوشی ها', id: 8 },
          { title: 'کامپیوتر ها', id: 9 },
        );
        this.appInformationItems.push(
          { title: 'علل 10-19', id: 1 },
          { title: 'کدهای 800', id: 2 },
          { title: 'کدهای گوشی', id: 3 },
          { title: 'تشخیص احتمالی پرستار', id: 4 },
          { title: 'اقلام مصرفی', id: 5 },
          // نوع ماموریت غیر فعال شد
          // {
          //   title: 'نوع ماموریت',
          //   id: 9,
          // },
          { title: 'برچسب ها', id: 6 },
          { title: 'توضیحات و ملاحظات', id: 7 },
          { title: 'شماره های داخلی', id: 8 },
        );
        this.drugItems.push(
          { title: 'واحد دارو', id: 1 },
          { title: 'نحوه تجویز دارو', id: 2 },
          { title: 'گروه های دارویی', id: 3 },
          { title: 'داروها', id: 4 },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
      } else if (moduleId === 2) {
        this.moduleName = '800 آسایار';
        //800
        this.menuItems.push(
          {
            title: 'داشبورد',
            icon: 'mdi-view-dashboard',
            type: '2',
            id: 1,
            module: '800',
          },
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 2,
            module: '800',
          },
          //NEW 800
          // {
          //   title: 'ماموریت های جدید',
          //   icon: 'mdi-clipboard-pulse',
          //   type: '2',
          //   id: 10,
          //   module: '800',
          // },
          { title: 'نقشه', icon: 'mdi-map', type: '2', id: 7, module: '800' },
          {
            title: 'کد ها',
            icon: 'mdi-ambulance mdi-flip-h',
            type: '2',
            id: 3,
            module: '800',
          },
          {
            title: 'کد های 10-7',
            icon: 'mdi-car-wrench',
            type: '2',
            id: 5,
            module: '800',
          },
          {
            title: 'لیست ترمینه',
            icon: 'mdi-email-arrow-right',
            type: '2',
            id: 7,
            module: '800',
          },
          {
            title: 'بیمارستان ها',
            icon: 'mdi-hospital-building',
            type: '2',
            id: 6,
            module: '800',
          },
          {
            title: 'ماموریت جدید',
            icon: 'mdi-car-emergency',
            type: '2',
            id: 8,
            module: '800',
          },
          {
            title: 'ماموریت استقرار',
            icon: 'mdi-ambulance mdi-flip-h',
            type: '2',
            id: 7,
            module: '800',
          },
          {
            title: 'اعلانات',
            icon: 'mdi-bullhorn-variant-outline',
            type: '2',
            id: 7,
            module: '800',
          },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '2',
            id: 9,
            module: '800',
          },
          { title: 'تنظیمات', icon: 'mdi-cog', type: '1', id: 4, module: '800' },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push(
          { title: 'گزارش پرونده ها', id: 1 },
          { title: 'تماس های اخیر', id: 2 },
        );
      } else if (moduleId == 3) {
        //115
        this.moduleName = '115 آسایار';
        this.menuItems.push(
          {
            title: 'داشبورد',
            icon: 'mdi-view-dashboard',
            type: '2',
            id: 1,
            module: '115',
          },
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 2,
            module: '115',
          },
          {
            title: 'ماموریت جدید',
            icon: 'mdi-car-emergency',
            type: '2',
            id: 3,
            module: '115',
          },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '2',
            id: 5,
            module: '115',
          },
          { title: 'تنظیمات', icon: 'mdi-cog', type: '1', id: 4, module: '115' },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push(
          { title: 'گزارش تماس ها', id: 1 },
          { title: 'گزارش پرونده ها', id: 2 },
          { title: 'گزارش تماس های اخیر ورودی', id: 3 },
        );
      } else if (moduleId == 6) {
        //admission
        this.moduleName = 'پذیرش آسایار';
        this.menuItems.push(
          {
            title: 'داشبورد',
            icon: 'mdi-view-dashboard',
            type: '2',
            id: 1,
            module: 'admission',
          },
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 2,
            module: 'admission',
          },
          {
            title: 'نقشه',
            icon: 'mdi-map',
            type: '2',
            id: 3,
            module: 'admission',
          },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '2',
            id: 9,
            module: 'admission',
          },
          {
            title: 'تنظیمات',
            icon: 'mdi-cog',
            type: '1',
            id: 4,
            module: 'admission',
          },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push({ title: 'گزارش پرونده ها', id: 1 });
      } else if (moduleId == 7) {
        //follow up
        this.moduleName = 'پیگیری آسایار';
        this.menuItems.push(
          {
            title: 'داشبورد',
            icon: 'mdi-view-dashboard',
            type: '2',
            id: 1,
            module: 'followUp',
          },
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 2,
            module: 'followUp',
          },
          { title: 'نقشه', icon: 'mdi-map', type: '2', id: 7, module: 'followUp' },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '2',
            id: 9,
            module: 'followUp',
          },
          {
            title: 'تنظیمات',
            icon: 'mdi-cog',
            type: '1',
            id: 3,
            module: 'followUp',
          },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push({ title: 'گزارش پرونده ها', id: 2 });
      } else if (moduleId === 8) {
        //doctor
        this.moduleName = 'دکتر آسایار';
        this.menuItems.push(
          {
            title: 'داشبورد',
            icon: 'mdi-view-dashboard',
            type: '2',
            id: 1,
            module: 'doctor',
          },
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 2,
            module: 'doctor',
          },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '2',
            id: 9,
            module: 'doctor',
          },
          {
            title: 'تنظیمات',
            icon: 'mdi-cog',
            type: '1',
            id: 3,
            module: 'doctor',
          },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push(
          { title: 'گزارش پرونده ها', id: 1 },
          { title: 'تماس های اخیر', id: 2 },
        );
      } else if (moduleId === 9) {
        //hospital
        this.moduleName = 'بیمارستان آسایار';
        this.menuItems.push(
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 2,
            module: 'hospital',
          },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '2',
            id: 9,
            module: 'hospital',
          },
          {
            title: 'تنظیمات',
            icon: 'mdi-cog',
            type: '1',
            id: 3,
            module: 'hospital',
          },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push({ title: 'گزارش پرونده ها', id: 1 });
      } else if (moduleId == 10) {
        //qc
        this.moduleName = 'کنترل کیفیت آسایار';
        this.menuItems.push(
          {
            title: 'داشبورد',
            icon: 'mdi-view-dashboard',
            type: '2',
            id: 1,
            module: 'qc',
          },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '1',
            id: 9,
            module: 'qc',
          },
          { title: 'تنظیمات', icon: 'mdi-cog', type: '1', id: 3, module: 'qc' },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
      } else if (moduleId == 11) {
        //qc
        this.moduleName = 'آمار آسایار';
        this.menuItems.push(
          {
            title: 'داشبورد',
            icon: 'mdi-view-dashboard',
            type: '2',
            id: 1,
            module: 'amar',
          },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '1',
            id: 9,
            module: 'amar',
          },
          {
            title: 'تنظیمات',
            icon: 'mdi-cog',
            type: '1',
            id: 3,
            module: 'amar',
          },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
      } else if (moduleId == 12) {
        //other organ
        this.moduleName = 'سازمان همکار آسایار';
        this.menuItems.push(
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 1,
            module: 'otherOrgan',
          },
          {
            title: 'تنظیمات',
            icon: 'mdi-cog',
            type: '1',
            id: 2,
            module: 'otherOrgan',
          },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
      } else if (moduleId === 14) {
        this.moduleName = 'کارشناس EOC آسایار';
        //Eoc
        this.menuItems.push(
          {
            title: 'ماموریت ها',
            icon: 'mdi-medication',
            type: '2',
            id: 2,
            module: 'eoc',
          },
          { title: 'نقشه', icon: 'mdi-map', type: '2', id: 7, module: 'eoc' },
          {
            title: 'گزارشات',
            icon: 'mdi-file-chart',
            type: '2',
            id: 9,
            module: 'eoc',
          },
          { title: 'تنظیمات', icon: 'mdi-cog', type: '1', id: 4, module: 'eoc' },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push(
          { title: 'گزارش پرونده ها', id: 1 },
        );
      } else if (moduleId === 15) {
        this.moduleName = 'داشبوردهای آسایار';
        //Doshboards
        this.menuItems.push(
          // {
          //   title: 'داشبورد پذیرش',
          //   icon: 'mdi-view-dashboard-variant-outline',
          //   type: '15',
          //   id: 3,
          //   module: 'dashboards',
          // },
          {
            title: 'داشبورد 115',
            icon: 'mdi-tablet-dashboard',
            type: '15',
            id: 1,
            module: 'dashboards',
            subMenu: [
              { title: 'عملکرد 115', id: 1 },
              { title: 'وضعیت اپراتور', id: 2 }
            ]
          },
          {
            title: 'داشبورد 800',
            icon: 'mdi-monitor-dashboard',
            type: '15',
            id: 2,
            module: 'dashboards',
          },

          // { title: 'تنظیمات', icon: 'mdi-cog', type: '1', id: 4, module: 'dashboards' },
        );
        this.settingItems.push({ title: 'تم', id: 1 });
        this.reportItems.push(
          { title: 'گزارش پرونده ها', id: 1 },
        );
      }
    },
    sendToUrlUser: function (title) {
      if (title == 'کاربران') {
        this.mini = true;
        this.$router.push({ name: 'user' });
      } else if (title == 'سمت ها') {
        this.mini = true;
        this.$router.push({ name: 'organizationRole' });
      } else if (title == 'گروه های کاربری') {
        this.mini = true;
        this.$router.push({ name: 'userGroup' });
      } else if (title == 'مدارک تحصیلی') {
        this.mini = true;
        this.$router.push({ name: 'educationDegree' });
      }
    },
    sendToUrlCountry: function (title) {
      if (title == 'استان') {
        this.mini = true;
        this.$router.push({ name: 'province' });
      } else if (title == 'شهرستان') {
        this.mini = true;
        this.$router.push({ name: 'city' });
      } else if (title == 'ناحیه') {
        this.mini = true;
        this.$router.push({ name: 'zone' });
      }
    },
    sendToUrlBaseInformation: function (title) {
      if (title == 'بیمارستان ها') {
        this.mini = true;
        this.$router.push({ name: 'hospital' });
      } else if (title == 'پایگاه ها') {
        this.mini = true;
        this.$router.push({ name: 'station' });
      } else if (title == 'سایر ارگان ها') {
        this.mini = true;
        this.$router.push({ name: 'otherOrganization' });
      } else if (title == 'نوع وسایل نقلیه') {
        this.mini = true;
        this.$router.push({ name: 'vehicleType' });
      } else if (title == 'سوالات عمومی') {
        this.mini = true;
        if (this.$route.name == 'generalTriageQuestion') {
          this.$router.push({ name: 'generalTriageQuestion' });
          window.location.reload();
        } else {
          this.$router.push({ name: 'generalTriageQuestion' });
        }
      } else if (title == 'افراد ناتوان') {
        this.mini = true;
        this.$router.push({ name: 'disabledPeople' });
      } else if (title == 'وسایل نقلیه') {
        this.mini = true;
        this.$router.push({ name: 'vehicle' });
      } else if (title == 'گوشی ها') {
        this.mini = true;
        this.$router.push({ name: 'phone' });
      } else if (title == 'کامپیوتر ها') {
        this.mini = true;
        this.$router.push({ name: 'clientComputer' });
      }
    },
    sendToUrlAppInformation: function (title) {
      if (title == 'علل 10-19') {
        this.mini = true;
        this.$router.push({ name: 'cancelReason' });
      } else if (title == 'کدهای 800') {
        this.mini = true;
        this.$router.push({ name: 'dispatchCode' });
      } else if (title == 'کدهای گوشی') {
        this.mini = true;
        this.$router.push({ name: 'flagData' });
      } else if (title == 'تشخیص احتمالی پرستار') {
        this.mini = true;
        this.$router.push({ name: 'chiefComplaint' });
      } else if (title == 'اقلام مصرفی') {
        this.mini = true;
        this.$router.push({ name: 'medicalItem' });
      } else if (title == 'برچسب ها') {
        this.mini = true;
        this.$router.push({ name: 'tag' });
      } else if (title == 'توضیحات و ملاحظات') {
        this.mini = true;
        this.$router.push({ name: 'preDefinedNote' });
      } else if (title == 'شماره های داخلی') {
        this.mini = true;
        this.$router.push({ name: 'extension' });
      }
      // نوع ماموریت غیر فعال شد
      //  else if (title === 'نوع ماموریت') {
      //   this.mini = true;
      //   this.$router.replace({ name: 'type_of_urgency' });
      // }
    },
    sendToUrlDrug: function (title) {
      if (title == 'واحد دارو') {
        this.mini = true;
        this.$router.push({ name: 'unit' });
      } else if (title == 'نحوه تجویز دارو') {
        this.mini = true;
        this.$router.push({ name: 'orderType' });
      } else if (title == 'گروه های دارویی') {
        this.mini = true;
        this.$router.push({ name: 'drugGroup' });
      } else if (title == 'داروها') {
        this.mini = true;
        this.$router.push({ name: 'drug' });
      }
    },
    sendToUrlReport: function (title, module) {
      if (title == 'گزارش تماس ها') {
        this.mini = true;
        this.navigateTo('callReport115');
      } else if (title == 'گزارش پرونده ها') {
        if (module == 'hospital') {
          this.mini = true;
          this.$router.push({ name: 'hospitalMissionReport' });
        } else {
          this.mini = true;
          this.navigateTo('missionReport');
        }
      } else if (title === 'تماس های اخیر') {
        if (module === '800') {
          this.mini = true;

          this.$router.push({ name: 'recent_800_calls' });
        } else if (module === 'doctor') {
          this.mini = true;
          this.$router.push({ name: 'doctor_recent_calls' });
        }
      } else if (title === 'گزارش تماس های اخیر ورودی') {
        this.mini = true;
        // this.$router.push({ name: 'userRecentCall115' });
        this.navigateTo('userRecentCall115');
      }

    },
    sendToUrlSetting: function (title) {
      if (title == 'تم') {
        this.mini = true;
        this.$router.push({ name: 'theme' });
      }
    },
    loadFromLocalStorage_selectStateMission() {
      const saved = localStorage.getItem('selectMissonState');
      if (saved == "true") {
        this.$router.push({ name: 'currentMission800' });
        // this.navigateTo('newMissionWithMap800');
        return
      }
      this.$router.push({ name: 'mission800' });
      // this.navigateTo('dispatchMap');
    },

    loadFromLocalStorage_selectMap() {
      const saved = localStorage.getItem('selectMissonState');
      if (saved == "true") {
        this.navigateTo('newMissionWithMap800');
        return
      }
      this.navigateTo('dispatchMap');
    },
    goToItems: function (title, module) {
      if (module == '115') {
        if (title == 'داشبورد') {
          this.mini = true;
          this.$router.push({ name: 'dashboard115' });
        } else if (title == 'ماموریت ها') {
          this.mini = true;
          this.$router.push({ name: 'mission115' });
        } else if (title === 'ماموریت جدید') {
          this.mini = true;
          this.activateNewCallFor800()
        } else if (title == 'گزارش تماس های اخیر ورودی') {
          this.mini = true;
          this.navigateTo('userRecentCall115');
        }
      } else if (module == '800') {
        if (title == 'داشبورد') {
          this.mini = true;

          this.navigateTo('dashboard800');
        } else if (title == 'ماموریت ها') {
          this.mini = true;
          this.loadFromLocalStorage_selectStateMission()
          // this.$router.push({ name: 'mission800' });
        } else if (title == 'کد ها') {
          this.mini = true;
          this.navigateTo('ambulance800List');
        } else if (title == 'کد های 10-7') {
          this.mini = true;
          this.navigateTo('ambulance107s');
        } else if (title == 'بیمارستان ها') {
          this.mini = true;

          this.navigateTo('hospital800List');
        } else if (title == 'نقشه') {
          this.loadFromLocalStorage_selectMap()
          // this.navigateTo('dispatchMap');
        } else if (title == 'ماموریت جدید') {
          this.mini = true;
          this.activateNewCallFor800();
        } else if (title === 'ماموریت استقرار') {
          this.mini = true;
          this.activateDeployment();
        } else if (title === 'اعلانات') {
          this.navigateTo('notification_for_800');
          this.mini = true;
        } else if (title === 'لیست ترمینه') {
          this.mini = true;
          this.navigateTo('terminehList');
        } else if (title === 'تنظیمات') {
          this.mini = true;
          this.$router.push({ name: 'setting800' });
        }
      } else if (module == 'admission') {
        if (title == 'داشبورد') {
          this.mini = true;
          this.$router.push({ name: 'dashboardAdmission' });
        } else if (title == 'ماموریت ها') {
          this.mini = true;
          this.$router.push({ name: 'admissionMissions' });
        } else if (title == 'نقشه') {
          this.navigateTo('admissionMap');
          // const routeData = this.$router.resolve({ name: "admissionMap" });
          // window.open(routeData.href, "_blank");
        }
      } else if (module == 'followUp') {
        if (title == 'داشبورد') {
          this.mini = true;
          this.$router.push({ name: 'dashboardFollowUp' });
        } else if (title == 'ماموریت ها') {
          this.mini = true;
          this.$router.push({ name: 'followUpMissions' });
        } else if (title == 'نقشه') {
          this.navigateTo('followUpMap');
        }
      } else if (module == 'doctor') {
        if (title == 'داشبورد') {
          this.mini = true;
          this.$router.push({ name: 'doctorDashboard' });
        } else if (title == 'ماموریت ها') {
          this.mini = true;
          this.$router.push({ name: 'doctorMissions' });
        }
      } else if (module == 'hospital') {
        if (title == 'ماموریت ها') {
          this.mini = true;
          this.$router.push({ name: 'hospitalMissions' });
        }
      } else if (module == 'qc') {
        if (title == 'داشبورد') {
          this.mini = true;
          this.$router.push({ name: 'qcDashboard' });
        } else if (title == 'گزارشات') {
          this.mini = true;
          this.$router.push({ name: 'qcReports' });
        }
      } else if (module == 'amar') {
        if (title == 'داشبورد') {
          this.mini = true;
          this.$router.push({ name: 'amarDashboard' });
        } else if (title == 'گزارشات') {
          this.mini = true;
          this.$router.push({ name: 'amarReports' });
        }
      } else if (module == 'otherOrgan') {
        if (title == 'ماموریت ها') {
          this.mini = true;
          this.$router.push({ name: 'otherOrganizationMissions' });
        }
      } else if (module == 'eoc') {
        if (title == 'ماموریت ها') {
          this.mini = true;
          this.$router.push({ name: 'currentMissionEoc' });
        } else if (title == 'نقشه') {
          this.navigateTo('eocMap');
        }
        // else if (title == 'گزارشات') {
        //   this.mini = true;
        //   this.$router.push({ name: 'qcReports' });
        // }
      } else if (module == 'dashboards') {
        // if (title == 'عملکرد 115') {
        if (title == 'داشبورد 115') {
          this.mini = true;
          this.$router.push({ name: 'dashboards_115' });
        } else if (title == 'وضعیت اپراتور') {
          this.mini = true;
          this.$router.push({ name: 'dashboards_time_status_115' });
        } else if (title == 'داشبورد 800') {
          this.mini = true;
          this.$router.push({ name: 'dashboards_800' });
        } else if (title == 'داشبورد پذیرش') {
          this.mini = true;
          this.$router.push({ name: 'dashboards_admission' });
        }
      }
    },
    changeUserModule: function (title, modduleId) {
      if (this.myModuleId == modduleId) {
        return;
      }
      if (title == 'Admin') {
        let id = modduleId.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.$router.push({ name: 'user' });
        localStorage.removeItem('extension');
        localStorage.removeItem('zone');
        window.location.reload();
      } else if (title == 'User115') {
        this.showChangeRoleModal('115');
      } else if (title == 'User800') {
        this.showChangeRoleModal('800');
      } else if (title == 'Admission') {
        this.showChangeRoleModal('admission');
      } else if (title == 'FollowUp') {
        this.showChangeRoleModal('followUp');
      } else if (title == 'Doctor') {
        this.showChangeRoleModal('doctor');
      } else if (title == 'Hospital') {
        this.showChangeRoleModal('hospital');
      } else if (title == 'QC') {
        this.showChangeRoleModal('qc');
      } else if (title === 'Statistic') {
        this.showChangeRoleModal('amar');
      } else if (title == 'OtherOrganization') {
        this.showChangeRoleModal('OtherOrganization');
      } else if (title == 'EOC') {
        this.showChangeRoleModal('eoc');
      } else if (title == 'Dashboard') {
        this.showChangeRoleModal('dashboards');
      }
    },
  },
};
